import React, { Fragment } from "react";

export const ONR_TrackTieRequirementsSchema = {
  sections: [
    {
      heights: {
        header1: "auto",
        header2: "auto",
      },
      minDataRowsCount: 10,
      columns: [
        {
          title: "Mileage",
          colSpan: 4,
          rowSpan: 1,
          className: "tbl-text-normal",
          columns: [
            {
              title: "From",
              colSpan: 2,
              rowSpan: 1,
              className: "tbl-text-normal",
              accessor: "from",
            },
            {
              title: "To",
              colSpan: 2,
              rowSpan: 1,
              className: "tbl-text-normal",
              accessor: "to",
            },
          ],
        },
        {
          title: "8' SW",
          colSpan: 2,
          rowSpan: 2,
          className: "tbl-text-normal",
          accessor: "sw8",
        },
        {
          title: "8' HW",
          colSpan: 2,
          rowSpan: 2,
          className: "tbl-text-normal",
          accessor: "hw8",
        },
        {
          title: "10' HW",
          colSpan: 2,
          rowSpan: 2,
          className: "tbl-text-normal",
          accessor: "hw10",
        },
        {
          title: "Remarks",
          colSpan: 8,
          rowSpan: 2,
          className: "tbl-text-normal",
          accessor: "com",
        },
      ],
    },
  ],
};



// WEBPACK FOOTER //
// ./src/components/Reports/ONR/TrackTieRequirements/ONR_TrackTieRequirementsSchema.js